// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import NoticeSvg from '@rsuite/icon-font/lib/status/Notice';
var Notice = createSvgIcon({
  as: NoticeSvg,
  ariaLabel: 'notice',
  category: 'status',
  displayName: 'Notice'
});
export default Notice;